import React from "react";
import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
   opacity: 1
  }

  50% {
    opacity: 0.5
  }

  100% {
    opacity: 1
  }
`;

const SVG = styled.svg`
  display: flex;
  flex-direction: column;
  animation: ${pulseAnimation} 1.25s infinite;
`;

const PicksSelectorLoading = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="581"
    viewBox="0 0 505 581"
    fill="none"
    preserveAspectRatio="none"
  >
    <g clipPath="url(#clip0_12221_35741)" filter="url(#filter0_d_12221_35741)">
      <rect
        width="501"
        height="577"
        transform="translate(2 2)"
        fill="var(--fd-colors-background-surface)"
      />
      <mask
        id="path-1-inside-1_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 2H503V99H2V2Z" />
      </mask>
      <path
        d="M503 97H2V101H503V97Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-1-inside-1_12221_35741)"
      />
      <rect
        width="40"
        height="95"
        transform="translate(2 2)"
        fill="var(--fd-colors-background-layer)"
      />
      <rect
        width="40"
        height="95"
        transform="translate(42 2)"
        fill="var(--fd-colors-background-layer)"
      />
      <rect
        x="50"
        y="22"
        width="24"
        height="18"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="50"
        y="54"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        width="40"
        height="95"
        transform="translate(82 2)"
        fill="var(--fd-colors-background-layer)"
      />
      <rect
        x="90"
        y="22"
        width="24"
        height="18"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="90"
        y="54"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        width="40"
        height="95"
        transform="translate(122 2)"
        fill="var(--fd-colors-background-layer)"
      />
      <rect
        x="130"
        y="22"
        width="24"
        height="18"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="130"
        y="54"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        width="341"
        height="95"
        transform="translate(162 2)"
        fill="var(--fd-colors-background-layer)"
      />
      <rect
        x="178"
        y="20.5"
        width="151"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="178"
        y="51"
        width="309"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="178"
        y="69"
        width="309"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-12-inside-2_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 99H42V139H2V99Z" />
      </mask>
      <path d="M2 99H42V139H2V99Z" fill="var(--fd-colors-background-surface)" />
      <path
        d="M42 138H2V140H42V138Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-12-inside-2_12221_35741)"
      />
      <rect
        x="12"
        y="109"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-15-inside-3_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 99H82V139H42V99Z" />
      </mask>
      <path
        d="M42 99H82V139H42V99Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 138H42V140H82V138Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-15-inside-3_12221_35741)"
      />
      <rect
        x="50"
        y="107"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-18-inside-4_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 99H122V139H82V99Z" />
      </mask>
      <path
        d="M82 99H122V139H82V99Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 138H82V140H122V138Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-18-inside-4_12221_35741)"
      />
      <rect
        x="90"
        y="107"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-21-inside-5_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 99H162V139H122V99Z" />
      </mask>
      <path
        d="M122 99H162V139H122V99Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 138H122V140H162V138Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-21-inside-5_12221_35741)"
      />
      <rect
        x="130"
        y="107"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-24-inside-6_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 99H503V139H162V99Z" />
      </mask>
      <path
        d="M162 99H503V139H162V99Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 138H162V140H503V138Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-24-inside-6_12221_35741)"
      />
      <rect
        x="178"
        y="113"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="113"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-28-inside-7_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 139H42V179H2V139Z" />
      </mask>
      <path
        d="M2 139H42V179H2V139Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 178H2V180H42V178Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-28-inside-7_12221_35741)"
      />
      <rect
        x="12"
        y="149"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-31-inside-8_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 139H82V179H42V139Z" />
      </mask>
      <path
        d="M42 139H82V179H42V139Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 178H42V180H82V178Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-31-inside-8_12221_35741)"
      />
      <rect
        x="50"
        y="147"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-34-inside-9_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 139H122V179H82V139Z" />
      </mask>
      <path
        d="M82 139H122V179H82V139Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 178H82V180H122V178Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-34-inside-9_12221_35741)"
      />
      <rect
        x="90"
        y="147"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-37-inside-10_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 139H162V179H122V139Z" />
      </mask>
      <path
        d="M122 139H162V179H122V139Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 178H122V180H162V178Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-37-inside-10_12221_35741)"
      />
      <rect
        x="130"
        y="147"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-40-inside-11_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 139H503V179H162V139Z" />
      </mask>
      <path
        d="M162 139H503V179H162V139Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 178H162V180H503V178Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-40-inside-11_12221_35741)"
      />
      <rect
        x="178"
        y="153"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="153"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-44-inside-12_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 179H42V219H2V179Z" />
      </mask>
      <path
        d="M2 179H42V219H2V179Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 218H2V220H42V218Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-44-inside-12_12221_35741)"
      />
      <rect
        x="12"
        y="189"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-47-inside-13_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 179H82V219H42V179Z" />
      </mask>
      <path
        d="M42 179H82V219H42V179Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 218H42V220H82V218Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-47-inside-13_12221_35741)"
      />
      <rect
        x="50"
        y="187"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-50-inside-14_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 179H122V219H82V179Z" />
      </mask>
      <path
        d="M82 179H122V219H82V179Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 218H82V220H122V218Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-50-inside-14_12221_35741)"
      />
      <rect
        x="90"
        y="187"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-53-inside-15_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 179H162V219H122V179Z" />
      </mask>
      <path
        d="M122 179H162V219H122V179Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 218H122V220H162V218Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-53-inside-15_12221_35741)"
      />
      <rect
        x="130"
        y="187"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-56-inside-16_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 179H503V219H162V179Z" />
      </mask>
      <path
        d="M162 179H503V219H162V179Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 218H162V220H503V218Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-56-inside-16_12221_35741)"
      />
      <rect
        x="178"
        y="193"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="193"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-60-inside-17_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 219H42V259H2V219Z" />
      </mask>
      <path
        d="M2 219H42V259H2V219Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 258H2V260H42V258Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-60-inside-17_12221_35741)"
      />
      <rect
        x="12"
        y="229"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-63-inside-18_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 219H82V259H42V219Z" />
      </mask>
      <path
        d="M42 219H82V259H42V219Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 258H42V260H82V258Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-63-inside-18_12221_35741)"
      />
      <rect
        x="50"
        y="227"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-66-inside-19_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 219H122V259H82V219Z" />
      </mask>
      <path
        d="M82 219H122V259H82V219Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 258H82V260H122V258Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-66-inside-19_12221_35741)"
      />
      <rect
        x="90"
        y="227"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-69-inside-20_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 219H162V259H122V219Z" />
      </mask>
      <path
        d="M122 219H162V259H122V219Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 258H122V260H162V258Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-69-inside-20_12221_35741)"
      />
      <rect
        x="130"
        y="227"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-72-inside-21_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 219H503V259H162V219Z" />
      </mask>
      <path
        d="M162 219H503V259H162V219Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 258H162V260H503V258Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-72-inside-21_12221_35741)"
      />
      <rect
        x="178"
        y="233"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="233"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-76-inside-22_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 259H42V299H2V259Z" />
      </mask>
      <path
        d="M2 259H42V299H2V259Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 298H2V300H42V298Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-76-inside-22_12221_35741)"
      />
      <rect
        x="12"
        y="269"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-79-inside-23_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 259H82V299H42V259Z" />
      </mask>
      <path
        d="M42 259H82V299H42V259Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 298H42V300H82V298Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-79-inside-23_12221_35741)"
      />
      <rect
        x="50"
        y="267"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-82-inside-24_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 259H122V299H82V259Z" />
      </mask>
      <path
        d="M82 259H122V299H82V259Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 298H82V300H122V298Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-82-inside-24_12221_35741)"
      />
      <rect
        x="90"
        y="267"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-85-inside-25_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 259H162V299H122V259Z" />
      </mask>
      <path
        d="M122 259H162V299H122V259Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 298H122V300H162V298Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-85-inside-25_12221_35741)"
      />
      <rect
        x="130"
        y="267"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-88-inside-26_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 259H503V299H162V259Z" />
      </mask>
      <path
        d="M162 259H503V299H162V259Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 298H162V300H503V298Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-88-inside-26_12221_35741)"
      />
      <rect
        x="178"
        y="273"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="273"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-92-inside-27_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 299H42V339H2V299Z" />
      </mask>
      <path
        d="M2 299H42V339H2V299Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 338H2V340H42V338Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-92-inside-27_12221_35741)"
      />
      <rect
        x="12"
        y="309"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-95-inside-28_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 299H82V339H42V299Z" />
      </mask>
      <path
        d="M42 299H82V339H42V299Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 338H42V340H82V338Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-95-inside-28_12221_35741)"
      />
      <rect
        x="50"
        y="307"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-98-inside-29_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 299H122V339H82V299Z" />
      </mask>
      <path
        d="M82 299H122V339H82V299Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 338H82V340H122V338Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-98-inside-29_12221_35741)"
      />
      <rect
        x="90"
        y="307"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-101-inside-30_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 299H162V339H122V299Z" />
      </mask>
      <path
        d="M122 299H162V339H122V299Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 338H122V340H162V338Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-101-inside-30_12221_35741)"
      />
      <rect
        x="130"
        y="307"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-104-inside-31_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 299H503V339H162V299Z" />
      </mask>
      <path
        d="M162 299H503V339H162V299Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 338H162V340H503V338Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-104-inside-31_12221_35741)"
      />
      <rect
        x="178"
        y="313"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="313"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-108-inside-32_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 339H42V379H2V339Z" />
      </mask>
      <path
        d="M2 339H42V379H2V339Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 378H2V380H42V378Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-108-inside-32_12221_35741)"
      />
      <rect
        x="12"
        y="349"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-111-inside-33_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 339H82V379H42V339Z" />
      </mask>
      <path
        d="M42 339H82V379H42V339Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 378H42V380H82V378Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-111-inside-33_12221_35741)"
      />
      <rect
        x="50"
        y="347"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-114-inside-34_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 339H122V379H82V339Z" />
      </mask>
      <path
        d="M82 339H122V379H82V339Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 378H82V380H122V378Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-114-inside-34_12221_35741)"
      />
      <rect
        x="90"
        y="347"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-117-inside-35_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 339H162V379H122V339Z" />
      </mask>
      <path
        d="M122 339H162V379H122V339Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 378H122V380H162V378Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-117-inside-35_12221_35741)"
      />
      <rect
        x="130"
        y="347"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-120-inside-36_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 339H503V379H162V339Z" />
      </mask>
      <path
        d="M162 339H503V379H162V339Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 378H162V380H503V378Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-120-inside-36_12221_35741)"
      />
      <rect
        x="178"
        y="353"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="353"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-124-inside-37_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 379H42V419H2V379Z" />
      </mask>
      <path
        d="M2 379H42V419H2V379Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 418H2V420H42V418Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-124-inside-37_12221_35741)"
      />
      <rect
        x="12"
        y="389"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-127-inside-38_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 379H82V419H42V379Z" />
      </mask>
      <path
        d="M42 379H82V419H42V379Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 418H42V420H82V418Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-127-inside-38_12221_35741)"
      />
      <rect
        x="50"
        y="387"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-130-inside-39_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 379H122V419H82V379Z" />
      </mask>
      <path
        d="M82 379H122V419H82V379Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 418H82V420H122V418Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-130-inside-39_12221_35741)"
      />
      <rect
        x="90"
        y="387"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-133-inside-40_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 379H162V419H122V379Z" />
      </mask>
      <path
        d="M122 379H162V419H122V379Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 418H122V420H162V418Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-133-inside-40_12221_35741)"
      />
      <rect
        x="130"
        y="387"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-136-inside-41_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 379H503V419H162V379Z" />
      </mask>
      <path
        d="M162 379H503V419H162V379Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 418H162V420H503V418Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-136-inside-41_12221_35741)"
      />
      <rect
        x="178"
        y="393"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="393"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-140-inside-42_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 419H42V459H2V419Z" />
      </mask>
      <path
        d="M2 419H42V459H2V419Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 458H2V460H42V458Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-140-inside-42_12221_35741)"
      />
      <rect
        x="12"
        y="429"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-143-inside-43_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 419H82V459H42V419Z" />
      </mask>
      <path
        d="M42 419H82V459H42V419Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 458H42V460H82V458Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-143-inside-43_12221_35741)"
      />
      <rect
        x="50"
        y="427"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-146-inside-44_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 419H122V459H82V419Z" />
      </mask>
      <path
        d="M82 419H122V459H82V419Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 458H82V460H122V458Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-146-inside-44_12221_35741)"
      />
      <rect
        x="90"
        y="427"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-149-inside-45_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 419H162V459H122V419Z" />
      </mask>
      <path
        d="M122 419H162V459H122V419Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 458H122V460H162V458Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-149-inside-45_12221_35741)"
      />
      <rect
        x="130"
        y="427"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-152-inside-46_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 419H503V459H162V419Z" />
      </mask>
      <path
        d="M162 419H503V459H162V419Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 458H162V460H503V458Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-152-inside-46_12221_35741)"
      />
      <rect
        x="178"
        y="433"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="433"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-156-inside-47_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 459H42V499H2V459Z" />
      </mask>
      <path
        d="M2 459H42V499H2V459Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 498H2V500H42V498Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-156-inside-47_12221_35741)"
      />
      <rect
        x="12"
        y="469"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-159-inside-48_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 459H82V499H42V459Z" />
      </mask>
      <path
        d="M42 459H82V499H42V459Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 498H42V500H82V498Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-159-inside-48_12221_35741)"
      />
      <rect
        x="50"
        y="467"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-162-inside-49_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 459H122V499H82V459Z" />
      </mask>
      <path
        d="M82 459H122V499H82V459Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 498H82V500H122V498Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-162-inside-49_12221_35741)"
      />
      <rect
        x="90"
        y="467"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-165-inside-50_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 459H162V499H122V459Z" />
      </mask>
      <path
        d="M122 459H162V499H122V459Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 498H122V500H162V498Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-165-inside-50_12221_35741)"
      />
      <rect
        x="130"
        y="467"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-168-inside-51_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 459H503V499H162V459Z" />
      </mask>
      <path
        d="M162 459H503V499H162V459Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 498H162V500H503V498Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-168-inside-51_12221_35741)"
      />
      <rect
        x="178"
        y="473"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="473"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-172-inside-52_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 499H42V539H2V499Z" />
      </mask>
      <path
        d="M2 499H42V539H2V499Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 538H2V540H42V538Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-172-inside-52_12221_35741)"
      />
      <rect
        x="12"
        y="509"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-175-inside-53_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 499H82V539H42V499Z" />
      </mask>
      <path
        d="M42 499H82V539H42V499Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 538H42V540H82V538Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-175-inside-53_12221_35741)"
      />
      <rect
        x="50"
        y="507"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-178-inside-54_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 499H122V539H82V499Z" />
      </mask>
      <path
        d="M82 499H122V539H82V499Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 538H82V540H122V538Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-178-inside-54_12221_35741)"
      />
      <rect
        x="90"
        y="507"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-181-inside-55_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 499H162V539H122V499Z" />
      </mask>
      <path
        d="M122 499H162V539H122V499Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 538H122V540H162V538Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-181-inside-55_12221_35741)"
      />
      <rect
        x="130"
        y="507"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-184-inside-56_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 499H503V539H162V499Z" />
      </mask>
      <path
        d="M162 499H503V539H162V499Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 538H162V540H503V538Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-184-inside-56_12221_35741)"
      />
      <rect
        x="178"
        y="513"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="513"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-188-inside-57_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M2 539H42V579H2V539Z" />
      </mask>
      <path
        d="M2 539H42V579H2V539Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M42 578H2V580H42V578Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-188-inside-57_12221_35741)"
      />
      <rect
        x="12"
        y="549"
        width="20"
        height="20"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-191-inside-58_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M42 539H82V579H42V539Z" />
      </mask>
      <path
        d="M42 539H82V579H42V539Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M82 578H42V580H82V578Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-191-inside-58_12221_35741)"
      />
      <rect
        x="50"
        y="547"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-194-inside-59_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M82 539H122V579H82V539Z" />
      </mask>
      <path
        d="M82 539H122V579H82V539Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M122 578H82V580H122V578Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-194-inside-59_12221_35741)"
      />
      <rect
        x="90"
        y="547"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-197-inside-60_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M122 539H162V579H122V539Z" />
      </mask>
      <path
        d="M122 539H162V579H122V539Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M162 578H122V580H162V578Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-197-inside-60_12221_35741)"
      />
      <rect
        x="130"
        y="547"
        width="24"
        height="24"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <mask
        id="path-200-inside-61_12221_35741"
        fill="var(--fd-colors-background-surface)"
      >
        <path d="M162 539H503V579H162V539Z" />
      </mask>
      <path
        d="M162 539H503V579H162V539Z"
        fill="var(--fd-colors-background-surface)"
      />
      <path
        d="M503 578H162V580H503V578Z"
        fill="var(--fd-colors-border-default)"
        mask="url(#path-200-inside-61_12221_35741)"
      />
      <rect
        x="178"
        y="553"
        width="38"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
      <rect
        x="224"
        y="553"
        width="200"
        height="12"
        rx="1"
        fill="var(--fd-colors-content-loading-default)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_12221_35741"
        x="0"
        y="0"
        width="505"
        height="581"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.913725 0 0 0 0 0.937255 0 0 0 0 0.960784 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12221_35741"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12221_35741"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_12221_35741">
        <rect
          width="501"
          height="577"
          fill="var(--fd-colors-background-surface)"
          transform="translate(2 2)"
        />
      </clipPath>
    </defs>
  </SVG>
);

export default PicksSelectorLoading;
